/** NotFound — 404 page. */
import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
	return (
		<div
			style={{
				minHeight: '100vh',
				display: 'grid',
				placeItems: 'center',
				background: 'var(--bg)',
				padding: 24,
			}}
		>
			<div className="card" style={{ maxWidth: 460, padding: 32, textAlign: 'center' }}>
				<div
					style={{
						fontFamily: 'var(--font-display)',
						fontSize: 48,
						fontWeight: 800,
						color: 'var(--navy-700)',
						lineHeight: 1,
					}}
				>
					404
				</div>
				<div
					style={{
						fontFamily: 'var(--font-display)',
						fontSize: 20,
						fontWeight: 700,
						margin: '12px 0 6px',
					}}
				>
					Page not found
				</div>
				<div style={{ color: 'var(--text-dim)', fontSize: 13, marginBottom: 18 }}>
					The page you tried to open doesn’t exist in this dashboard.
				</div>
				<Link to="/banks/submission-status" className="btn">
					Go to Bank Submission Status
				</Link>
			</div>
		</div>
	);
}
